<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" :isShowMore="true" />
    <pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize" :config="config"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights" >
      <li v-if='rights("Print") ' :title='rs["mcard"]' :class='selIdx!=undefined? "nav-system":"nav-system disabled"'>
        <a href="javascript:" @click='makeCard'><span class='icon iconfontx icon-yuangongqia'></span></a>
      </li>
      <li v-if='rights("Print") ' :title='rs["mcardp"]' class="nav-system">
        <a href="javascript:" @click='FmakeCard'><span class='icon iconfontx icon-stuff-card'></span></a>
      </li>
      <li title='同步新员工' class="nav-system">
        <a href="javascript:" @click='syncEmp'>同步新员工</a>
      </li>
       <li title='同步到OA' class="nav-system">
        <a href="javascript:" @click='HRtoOA'>同步到OA</a>
      </li>
    </pager-panel>
    <list-panel  :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />
    <component v-if="isShowDetail" v-bind:is="detailView" :url="config.url" @back="back"
    :action="detailAction" :detailData="detailData" :rs="rs" :autoId="config.autoId" :config="config">
      <a class="btn btn-default" @click="back">{{$rs["btn_back"]}}</a>
    </component>
    <batch-print v-if="showBatch" :config="config" :rs="rs" @closeBP="closeBP"/>
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {
  created: function() {
    if (this.config.dept) {
      this.config.dept.forEach(d => {
        this.config.params.dept.options.push({
          value: d.deptNo,
          text: d.deptName
        });
      });
    }
  },
  data() {
    return {
      config: data,
      showBatch: false
    };
  },
  methods: {
    initDetail(el) {
      if (!this.config.bc || !this.config.bz || !this.config.plan)
        this.$getData(this.config.url + "detail", this.openDetail);
      else this.isShowDetail = true;
    },

    syncEmp() {
      this.$getData(this.config.url + "syncEmp?" + this.$urlSq(), data => {
        if (data && data.rs == 1) {
          this.$alert("同步成功！");
          this.$loadData(this.config);
        }
      });
    },

 HRtoOA() {
      this.$getData(this.config.url + "HRtoOA?" + this.$urlSq(), data => {
        if (data && data.rs == 1) {
          this.$alert("同步成功！");
          this.$loadData(this.config);
        }
      });
    },

    makeCard() {
      const arr = [];
      const rows = this.getSelRows();
      rows.forEach(d => {
        arr.push(d.autoid);
      });
      if (arr.length <= 0) return;
      this.$postData("report/MakeCard", arr, this.marCardCallback);
    },
    closeBP() {
      this.showBatch = false;
    },
    FmakeCard() {
      this.showBatch = true;
    },
    marCardCallback(data) {
      window.open(this.$apiUrl + "fm/download?fileName=" + data.file);
    }
  },
  components: {
    "detail-panel": () => import("./detail"),
    "batch-print": () => import("./batchPrint")
  },
  mixins: [mixin.list]
};
</script>
